/**
 * @generated SignedSource<<9515a389934c435a7dab17902dcc06cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillAssessmentsByStudentFilterInput = {
  skillCode?: string | null | undefined;
  skillId?: string | null | undefined;
};
export type AllUserActionFilterInput = {
  actionTypeId?: ReadonlyArray<string> | null | undefined;
  dataFrom?: any | null | undefined;
  diagnosticSessionId?: any | null | undefined;
  skillCodes?: ReadonlyArray<string> | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  userId?: string | null | undefined;
};
export type StudentSingleSkillQuery$variables = {
  allUserActionsFilter: AllUserActionFilterInput;
  skillAssessmentsByStudentFilter?: SkillAssessmentsByStudentFilterInput | null | undefined;
  skillCode: string;
  skip: boolean;
  studentId: string;
};
export type StudentSingleSkillQuery$data = {
  readonly allUserActions: {
    readonly nodes: ReadonlyArray<{
      readonly actionType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly description: string;
      readonly timeStamp: any;
    }> | null | undefined;
  } | null | undefined;
  readonly currentTargetGroupByStudentId?: {
    readonly id: string;
    readonly isActive: boolean;
    readonly isCurrent: boolean;
    readonly targetGroup: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly latestCompletedStudentSkillDiagnostic: {
    readonly id: string;
    readonly retakeAssigned: boolean;
    readonly sessionCompletedOn: any;
  } | null | undefined;
  readonly skillAssessmentsByStudentId: {
    readonly nodes: ReadonlyArray<{
      readonly activityId: string | null | undefined;
      readonly id: string;
      readonly items: ReadonlyArray<{
        readonly id: string;
        readonly score: number | null | undefined;
      } | null | undefined> | null | undefined;
      readonly maxScore: number;
      readonly score: number;
      readonly sessionCompletedOn: any;
      readonly sessionId: any;
      readonly skill: {
        readonly id: string;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly skillStatesByStudentId: ReadonlyArray<{
    readonly id: string;
    readonly inProgress: boolean;
    readonly readinessScore: any | null | undefined;
    readonly skill: {
      readonly code: string | null | undefined;
      readonly essentialQuestion: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skillStories: ReadonlyArray<{
        readonly id: string;
        readonly profession: string | null | undefined;
        readonly story: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly summary: string | null | undefined;
      readonly vocabularies: ReadonlyArray<{
        readonly definition: string | null | undefined;
        readonly id: string;
        readonly term: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly skillAssessment: {
      readonly id: string;
      readonly isComplete: boolean;
      readonly maxScore: number;
      readonly score: number;
    } | null | undefined;
    readonly skillSubstate: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skillState: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  }>;
};
export type StudentSingleSkillQuery = {
  response: StudentSingleSkillQuery$data;
  variables: StudentSingleSkillQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allUserActionsFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillAssessmentsByStudentFilter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillCode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v5 = {
  "kind": "Variable",
  "name": "studentId",
  "variableName": "studentId"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxScore",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionCompletedOn",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "filter",
      "variableName": "skillAssessmentsByStudentFilter"
    },
    (v5/*: any*/)
  ],
  "concreteType": "StudentSkillAssessmentNodeConnection",
  "kind": "LinkedField",
  "name": "skillAssessmentsByStudentId",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StudentSkillAssessmentNode",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sessionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillNode",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StudentSkillAssessmentItemNode",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  (v5/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = [
  (v6/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "condition": "skip",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v12/*: any*/),
      "concreteType": "StudentTargetGroupNode",
      "kind": "LinkedField",
      "name": "currentTargetGroupByStudentId",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TargetGroupNode",
          "kind": "LinkedField",
          "name": "targetGroup",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNode",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v16 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "skillCodes.0",
              "variableName": "skillCode"
            }
          ],
          "kind": "ListValue",
          "name": "skillCodes"
        }
      ],
      "kind": "ObjectValue",
      "name": "filter"
    },
    (v5/*: any*/)
  ],
  "concreteType": "StudentSkillNode",
  "kind": "LinkedField",
  "name": "skillStatesByStudentId",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readinessScore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StudentSkillAssessmentNode",
      "kind": "LinkedField",
      "name": "skillAssessment",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComplete",
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillSubstateNode",
      "kind": "LinkedField",
      "name": "skillSubstate",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillStateNode",
          "kind": "LinkedField",
          "name": "skillState",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillNode",
      "kind": "LinkedField",
      "name": "skill",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "essentialQuestion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillStoryNode",
          "kind": "LinkedField",
          "name": "skillStories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "story",
              "storageKey": null
            },
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profession",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VocabularyNode",
          "kind": "LinkedField",
          "name": "vocabularies",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "term",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "definition",
              "storageKey": null
            },
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "allUserActionsFilter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "timeStamp": "DESC"
      }
    ]
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeStamp",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ActionTypeNode",
  "kind": "LinkedField",
  "name": "actionType",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": (v12/*: any*/),
  "concreteType": "StudentSkillDiagnosticNode",
  "kind": "LinkedField",
  "name": "latestCompletedStudentSkillDiagnostic",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retakeAssigned",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentSingleSkillQuery",
    "selections": [
      (v11/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "alias": null,
        "args": (v17/*: any*/),
        "concreteType": "UserActionNodeConnection",
        "kind": "LinkedField",
        "name": "allUserActions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserActionNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v21/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StudentSingleSkillQuery",
    "selections": [
      (v11/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "alias": null,
        "args": (v17/*: any*/),
        "concreteType": "UserActionNodeConnection",
        "kind": "LinkedField",
        "name": "allUserActions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserActionNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v21/*: any*/)
    ]
  },
  "params": {
    "cacheID": "7a72fcc454e18b4fd190dc235dac720c",
    "id": null,
    "metadata": {},
    "name": "StudentSingleSkillQuery",
    "operationKind": "query",
    "text": "query StudentSingleSkillQuery(\n  $studentId: ID!\n  $skillCode: String!\n  $skip: Boolean!\n  $skillAssessmentsByStudentFilter: SkillAssessmentsByStudentFilterInput\n  $allUserActionsFilter: AllUserActionFilterInput!\n) {\n  skillAssessmentsByStudentId(studentId: $studentId, filter: $skillAssessmentsByStudentFilter) {\n    nodes {\n      id\n      activityId\n      sessionId\n      skill {\n        id\n      }\n      score\n      maxScore\n      sessionCompletedOn\n      items {\n        id\n        score\n      }\n    }\n  }\n  currentTargetGroupByStudentId(studentId: $studentId) @skip(if: $skip) {\n    id\n    isCurrent\n    isActive\n    targetGroup {\n      id\n      name\n    }\n    user {\n      id\n    }\n  }\n  skillStatesByStudentId(studentId: $studentId, filter: {skillCodes: [$skillCode]}) {\n    id\n    inProgress\n    readinessScore\n    skillAssessment {\n      id\n      score\n      isComplete\n      maxScore\n    }\n    skillSubstate {\n      id\n      name\n      skillState {\n        id\n        name\n      }\n    }\n    skill {\n      id\n      code\n      name\n      summary\n      essentialQuestion\n      skillStories {\n        story\n        id\n        profession\n      }\n      vocabularies {\n        term\n        definition\n        id\n      }\n    }\n  }\n  allUserActions(first: 1, filter: $allUserActionsFilter, order: [{timeStamp: DESC}]) {\n    nodes {\n      timeStamp\n      description\n      actionType {\n        id\n        name\n      }\n      id\n    }\n  }\n  latestCompletedStudentSkillDiagnostic(studentId: $studentId) {\n    id\n    retakeAssigned\n    sessionCompletedOn\n  }\n}\n"
  }
};
})();

(node as any).hash = "9334572f8215c79073540fe426ef29e2";

export default node;
